module.exports = __webpack_public_path__ + "static/media/dat.feabcd5c.png";